import { jsx as _jsx } from "react/jsx-runtime";
import { reportErrorToBugsnag } from "@air/utils-error";
import noop from "lodash/noop";
import { createContext, useContext, useMemo, useRef } from "react";
import { isDevOrTestStage } from "~/swr-hooks/utils";
const defaultValue = {
    getFiltersModifiedManually: ()=>false,
    setFiltersModifiedManually: noop
};
const FiltersModifiedManuallyContext = /*#__PURE__*/ createContext(defaultValue);
export const FiltersModifiedManuallyProvider = (param)=>{
    let { children } = param;
    // set true as default, so that filters can be put in redux on first render
    const filtersModifiedManually = useRef(true);
    const value = useMemo(()=>({
            getFiltersModifiedManually: ()=>filtersModifiedManually.current,
            setFiltersModifiedManually: (value)=>{
                filtersModifiedManually.current = value;
            }
        }), []);
    return /*#__PURE__*/ _jsx(FiltersModifiedManuallyContext.Provider, {
        value: value,
        children: children
    });
};
export const useFiltersModifiedManuallyContext = ()=>{
    const context = useContext(FiltersModifiedManuallyContext);
    if (context === defaultValue) {
        const error = "FiltersModifiedManuallyContext used outside of FiltersModifiedManuallyProvider";
        if (isDevOrTestStage()) {
            throw error;
        } else {
            reportErrorToBugsnag({
                error,
                context: error
            });
        }
    }
    return context;
};
